import React, { useState, useEffect } from 'react';
import config from '../config';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Link } from 'react-router-dom';

const Links = ({ testMode = false }) => {
    
  const host = config.backendUrl;

  const [products, setProducts] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [authToken, setAuthToken] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getAuthToken = async () => {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens.idToken.toString();
        setAuthToken(token);
      } catch (error) {
        console.error('Error getting auth token:', error);
      }
    };
    
    getAuthToken();
  }, []);

  useEffect(() => {
    if (!authToken) return; // Don't fetch if no token yet

    fetch(`${host}/api/admin/products`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
      .then(response => {
        if (!response.ok) {
          console.log(response);
          // throw new Error('Network response was not ok');
          // console.error('Error fetching products:', response.statusText);
        }
        return response.json();
      })
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching products:', error);
        setLoading(false);
      });
  }, [authToken, refresh]);

  return (
    <div className="main-content">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-header-title">
            Manage Users
            {testMode && <span style={{color: 'var(--warning-color)'}}> (Test Mode)</span>}
          </h1>
        </div>
        <div className="page-header-actions">
          <Link to={testMode ? "/test" : "/"} className="btn btn-secondary">
            ← Back Home
          </Link>
          <button 
            className="btn btn-ghost" 
            onClick={() => {
              window.location.href = testMode ? '/users' : '/test/users';
              setRefresh(!refresh);
            }}
          >
            🔄 Toggle Mode
          </button>
        </div>
      </div>

      {/* Admin Users Table */}
      <div className="card" style={{ marginBottom: 'var(--spacing-2xl)' }}>
        <div className="card-header">
          <h3 className="card-title">Sandbox Builder Links</h3>
        </div>
        <div className="card-body" style={{ padding: 0 }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: 'var(--spacing-3xl)' }}>
              <div className="spinner" style={{ margin: '0 auto' }}></div>
              <p style={{ marginTop: 'var(--spacing-md)', color: 'var(--text-secondary)' }}>
                Loading links...
              </p>
            </div>
          ) : (
            <div className="table-container" style={{ margin: 0, borderRadius: 0 }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>Product ID</th>
                    <th>Builder Link</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {productId: "look-to-the-sky", link: "https://sandbox.d2sn986t6fv7ti.amplifyapp.com/books/look-to-the-sky/personalize"},
                    {productId: "look-to-the-sky-adults", link: "https://sandbox.d2sn986t6fv7ti.amplifyapp.com/books/look-to-the-sky-adults/personalize"}
                  ].map(product => (
                    <tr key={product.productId}>
                      <td style={{ fontFamily: 'var(--font-family-mono)', fontWeight: 'var(--font-weight-medium)' }}>
                        {product.productId}
                      </td>
                      <td>{product.link}</td>
                      <td style={{ fontWeight: 'var(--font-weight-medium)', color: 'var(--text-primary)' }}>
                        <a href={product.link} target="_blank" rel="noopener noreferrer">Open Link</a>
                      </td>
                      {/* <td>
                        <span className="badge badge-success">Active</span>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      
      {/* Live Links Table */}
      <div className="card" style={{ marginBottom: 'var(--spacing-2xl)' }}>
        <div className="card-header">
          <h3 className="card-title">Live Builder Links</h3>
        </div>
        <div className="card-body" style={{ padding: 0 }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: 'var(--spacing-3xl)' }}>
              <div className="spinner" style={{ margin: '0 auto' }}></div>
              <p style={{ marginTop: 'var(--spacing-md)', color: 'var(--text-secondary)' }}>
                Loading links...
              </p>
            </div>
          ) : (
            <div className="table-container" style={{ margin: 0, borderRadius: 0 }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>Product ID</th>
                    <th>Builder Link</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {productId: "look-to-the-sky", link: "https://dandelion.grieversandfriends.com/books/look-to-the-sky/personalize"},
                    {productId: "look-to-the-sky-adults", link: "https://dandelion.grieversandfriends.com/books/look-to-the-sky-adults/personalize"}
                  ].map(product => (
                    <tr key={product.productId}>
                      <td style={{ fontFamily: 'var(--font-family-mono)', fontWeight: 'var(--font-weight-medium)' }}>
                        {product.productId}
                      </td>
                      <td>{product.link}</td>
                      <td style={{ fontWeight: 'var(--font-weight-medium)', color: 'var(--text-primary)' }}>
                        <a href={product.link} target="_blank" rel="noopener noreferrer">Open Link</a>
                      </td>
                      {/* <td>
                        <span className="badge badge-success">Active</span>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      
    </div>
    
  );
}

export default Links;